/* eslint-disable react-hooks/exhaustive-deps */
import './index.less';

import {
  Box,
  Divider,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrgStore } from 'src/models/useOrgModel';
import {
  creditOneConsumptionFeatureShow,
  useUicPermissions,
} from '@Models/useUicPermissions';
import DataTrack from '../../components/DataTrack';
import { useDashboardDaysStore } from '../../models/useDashboardDaysModel';
import { useSearchParams } from 'react-router-dom';
import LicenseExpiredBanner from '@Components/Banner/LicenseExpiredBanner';
import { isInUIC } from '@Utils/common';
import { MSAuditLogBanner } from '../../components/Banner/MSAuditLogBanner';
import AcsRetirementBanner from '@Components/Banner/AcsRetirementBanner';
import {
  ProvisionTab,
  ThreatDetectionTab,
  RiskUserTab,
  RecommendConfigTab,
} from './tabs';
import SpodMigrationBanner from '@Components/Banner/SpodMigrationBanner';
import CreditDrawerButton from '@Components/CreditDrawerButton';
import TrialExpiringBanner from '@Components/Banner/TrialExpiringBanner';

enum TabType {
  Provision = 'provision',
  Dashboard = 'dashboard',
  ConfigurationHealth = 'configurationHealth',
}

const Dashboard = () => {
  const [queryParameters, setQueryParameters] = useSearchParams();
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { switchOrgId, defaultSingleOrgId } = useOrgStore();
  const daysModel = useDashboardDaysStore();
  const [tabIndex, setTabIndex] = useState(1);
  const { data: permissionsData } = useUicPermissions();
  const isCreditOneConsumptionFeatureShow =
    creditOneConsumptionFeatureShow(permissionsData);

  useEffect(() => {
    daysModel.loadLocalStorage();
    const tabType = queryParameters.get('type');
    if (tabType === TabType.Provision) {
      setTabIndex(0);
    } else if (tabType === TabType.ConfigurationHealth) {
      setTabIndex(3);
      setQueryParameters('');
    }
  }, []);

  // if orgId == all, switch to other org
  const enterNoAllTab = () => {
    if (defaultSingleOrgId) {
      switchOrgId(defaultSingleOrgId);
    }
  };
  return (
    <Box
      bg={
        colorMode === 'dark'
          ? colorStyle.background.primary
          : colorStyle.background.secondary
      }
      pt="8px"
    >
      <Box m="12px 12px">
        <MSAuditLogBanner />
      </Box>
      {!isInUIC() && (
        <Box m="12px 12px">
          <LicenseExpiredBanner />
        </Box>
      )}
      {isInUIC() && (
        <Box m="12px 12px">
          <TrialExpiringBanner />
        </Box>
      )}
      <Box m="12px 12px">
        <SpodMigrationBanner />
      </Box>
      <AcsRetirementBanner />
      <Tabs
        defaultIndex={1}
        index={tabIndex}
        onChange={(index: number) => {
          setTabIndex(index);
        }}
      >
        <Flex justify="space-between" align="center" pr="16px">
          <TabList>
            <DataTrack type="MainPage.Tab.ServiceStatus">
              <Tab onClick={enterNoAllTab}>
                {t('dashboard.tabs.serviceStatus')}
              </Tab>
            </DataTrack>

            <DataTrack type="MainPage.Tab.Dashboard">
              <Tab>{t('dashboard.tabs.threatDetection')}</Tab>
            </DataTrack>
            <DataTrack type="MainPage.Tab.UserDetection">
              <Tab>{t('dashboard.tabs.userDetection')}</Tab>
            </DataTrack>
            <DataTrack type="MainPage.Tab.ConfigRecommendation">
              <Tab onClick={enterNoAllTab}>
                {t('dashboard.tabs.securityConfiguration')}
              </Tab>
            </DataTrack>
          </TabList>
          {isInUIC() && isCreditOneConsumptionFeatureShow && (
            <CreditDrawerButton />
          )}
        </Flex>
        <Divider position="relative" top="-1px" />
        <TabPanels>
          {[
            ProvisionTab,
            ThreatDetectionTab,
            RiskUserTab,
            RecommendConfigTab,
          ].map(
            //eslint-disable-next-line @typescript-eslint/naming-convention
            (Ele) => {
              return (
                <TabPanel>
                  {(args) => (!args.isSelected ? null : <Ele />)}
                </TabPanel>
              );
            }
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Dashboard;
